/*
  NYGHT -- Cloudflare Turnstile (2026-10-02). Same approach as the Cosnetic/BARE contact forms.

  Every <div class="nn-turnstile" data-sitekey="..."> on the page becomes a Turnstile widget. The
  widget has pre-clearance switched on in Cloudflare, so a solved widget also gives the browser a
  cf_clearance cookie -- which is what lets a human's POST /contact through the "managed challenge
  on contact-form posts" WAF rule without ever seeing a challenge page. Shopify's own form endpoint
  cannot verify a token, so the token itself is never posted; the clearance cookie does the work.

  data-gate="#formId"       submit button of that form stays disabled until the widget is solved
  data-appearance           "always" (visible box, the contact form) or "interaction-only" (footer:
                            invisible unless Cloudflare needs a click)
  data-wait="1"             on submit, wait up to 4 s for a token before letting the form go (footer
                            newsletter: never blocks a human, just gives the clearance time to land)
*/
(function () {
  if (window.nnTurnstileBoot) return;   // the snippet may be rendered twice on one page (form + footer)
  window.nnTurnstileBoot = true;
  var SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=nnTurnstileReady';
  var boxes = Array.prototype.slice.call(document.querySelectorAll('.nn-turnstile[data-sitekey]'));
  if (!boxes.length) return;

  function form(box) { var sel = box.getAttribute('data-gate'); return sel ? document.querySelector(sel) : box.closest('form'); }
  function submitOf(f) { return f ? f.querySelector('[type="submit"]') : null; }
  function note(box, on) { var n = box.parentElement && box.parentElement.querySelector('.nn-captcha-note'); if (n) n.classList.toggle('is-on', !!on); }

  boxes.forEach(function (box) {
    box.nnToken = '';
    var f = form(box), b = submitOf(f);
    if (b && box.getAttribute('data-gate')) { b.disabled = true; b.setAttribute('data-nn-gated', '1'); }
    if (f && box.getAttribute('data-wait') === '1') {
      f.addEventListener('submit', function (e) {
        if (box.nnToken || !window.turnstile || f.nnWaited) return;
        e.preventDefault();
        var t0 = Date.now();
        (function tick() {
          if (box.nnToken || Date.now() - t0 > 4000) { f.nnWaited = true; f.requestSubmit ? f.requestSubmit() : f.submit(); return; }
          setTimeout(tick, 120);
        })();
      });
    }
  });

  // A widget rendered inside a hidden container (the contact form before a topic is picked) never sizes,
  // so hidden boxes wait; the contact section dispatches 'nn:reveal' on document when the form unfolds.
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  document.addEventListener('nn:reveal', function () { if (window.turnstile) window.nnTurnstileReady(); });
  window.nnTurnstileReady = function () {
    boxes.forEach(function (box) {
      if (box.nnRendered || !visible(box)) return;
      box.nnRendered = true;
      var f = form(box), b = submitOf(f);
      try {
        window.turnstile.render(box, {
          sitekey: box.getAttribute('data-sitekey'),
          appearance: box.getAttribute('data-appearance') || 'always',
          theme: 'light',
          language: (document.documentElement.lang || 'auto').slice(0, 2),
          'refresh-expired': 'auto',
          callback: function (token) { box.nnToken = token; if (b && b.getAttribute('data-nn-gated')) b.disabled = false; note(box, false); },
          'expired-callback': function () { box.nnToken = ''; if (b && b.getAttribute('data-nn-gated')) b.disabled = true; },
          'error-callback': function () { box.nnToken = ''; note(box, true); }
        });
      } catch (err) { note(box, true); }
    });
  };

  function load() {
    if (window.nnTurnstileLoading) return; window.nnTurnstileLoading = true;
    var s = document.createElement('script');
    s.src = SRC; s.async = true; s.defer = true;
    s.onerror = function () { boxes.forEach(function (box) { note(box, true); }); };
    document.head.appendChild(s);
    // Blocked by a content blocker: the script never loads and never errors. Say so after 8 s.
    setTimeout(function () { if (!window.turnstile) boxes.forEach(function (box) { note(box, true); }); }, 8000);
  }
  // Speed (2026-10-10): Cloudflare's script is ~0,7 MB. Pages with a gated form (contact/returns) load it at once;
  // pages that only have the footer newsletter load it when someone starts using that form.
  if (boxes.some(function (box) { return box.getAttribute('data-gate'); })) { load(); return; }
  boxes.forEach(function (box) {
    var f = form(box); if (!f) return;
    ['focusin', 'pointerdown', 'touchstart'].forEach(function (ev) { f.addEventListener(ev, load, { once: true, passive: true }); });
  });
})();
